module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#twitter",
      toString: function () {
        return this.url;
      }
    }